import { createContext } from 'react';
import { projectConfigs, ProjectConfig } from './projectConfigs';

const themeVariable = import.meta.env.VITE_COLOR_THEME || '';
const config = (projectConfigs[themeVariable] || projectConfigs.default)!;

export const ConfigContext = createContext<ProjectConfig>(config);
